
import {NgModule} from '@angular/core';
import {EntityDataService, EntityServices} from '@ngrx/data';
import {MedicalPractitionerDataService} from './impl/service/ngrx/medicalPractitionerData.service';
import {MedicalPractitionerRepository} from './impl/service/ngrx/medicalPractitioner.repository';

@NgModule()
export class MedicalRecordPractitionerModule {
    constructor(entityDataService: EntityDataService,
                entityServices: EntityServices,
                dataService: MedicalPractitionerDataService,
                repository: MedicalPractitionerRepository,
    ) {

        entityDataService.registerServices({
            MedicalPractitioner: dataService,
        });

        entityServices.registerEntityCollectionServices({
            MedicalPractitioner: repository,
        });


    }
}
